var o2 = "/static/713a52d7e65c41d4.png";

export { o2 as default };
//# sourceMappingURL=o_2.png.js.map
